import 'dayjs/locale/ur'

const ur = {
  calendar: {
    sameDay: '[آج بوقت] LT',
    nextDay: '[کل بوقت] LT',
    nextWeek: 'dddd [بوقت] LT',
    lastDay: '[گذشتہ روز بوقت] LT',
    lastWeek: '[گذشتہ] dddd [بوقت] LT',
    sameElse: 'L'
  }
}

export default ur
